module.exports = __webpack_public_path__ + "img/za.855c9dc1.svg";